<script setup lang="ts">
const props = defineProps<{
  resourceId?: number
  resourceType?: ResourceType
}>()

const { data: userInfo } = useAuth()
const count = ref(0)
const $toast = useToast()
const emit = defineEmits(['success', 'cancel'])

watch(props, () => {
  count.value = 0
})

function cancel() {
  emit('cancel')
}
async function submit() {
  const res = await requestRewardResource(
    props.resourceId!,
    props.resourceType!,
    count.value
  )
  if (res.code === 1) {
    $toast.success('打赏成功')
    emit('success')
    useEmitter().emit('rewardSuccess', {
      resourceId: props.resourceId!,
      resourceType: props.resourceType!,
      count: count.value
    })
  } else {
    $toast.error(res.msg)
  }
}
</script>

<template>
  <div class="m-reward-form">
    <div class="m-reward-form__header">打赏</div>
    <div class="m-reward-form__body">
      <n-rate size="large" @update-value="count = $event">
        <m-icon icon="ni ni-coin" :size="32" />
      </n-rate>
    </div>
    <div class="m-reward-form__footer">
      打赏 {{ count }} 喵币，当前剩余 {{ userInfo.user.neko_coin }} 喵币
    </div>

    <n-button
      type="primary"
      block
      strong
      class="m-reward-form__button"
      @click="submit"
    >
      提交
    </n-button>
    <n-button block strong class="m-reward-form__button" @click="cancel">
      取消
    </n-button>
  </div>
</template>

<style lang="scss" scoped>
.m-reward-form {
  width: 100%;
  padding: 0 24px;
  background-color: #fff;
  border-radius: 8px;

  &__header {
    display: flex;
    pointer-events: none;
    font-size: 18px;
    margin-bottom: 12px;
  }
  &__body {
    display: flex;
    justify-content: center;
    margin-bottom: 12px;
  }
  &__footer {
    display: flex;
    justify-content: center;
    color: #999;
    font-size: 14px;
    margin-bottom: 12px;
  }
  &__button {
    margin-top: 12px;
  }
}
</style>
